<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-lessThan`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.6738 2.90621C11.9936 2.72595 12.3995 2.83858 12.5801 3.15816C12.7602 3.47778 12.6475 3.8838 12.3281 4.06441L5.35352 8.00094L12.3281 11.9384C12.6475 12.1191 12.7604 12.525 12.5801 12.8447C12.3996 13.1644 11.9936 13.2768 11.6738 13.0966L3.67285 8.58102C3.46413 8.46317 3.33417 8.24158 3.33398 8.00191C3.33398 7.76215 3.46415 7.54078 3.67285 7.42281L11.6738 2.90621Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineLessThan',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
